import React, { Component } from 'react';
import { AppLogo } from './common';

export class Title extends Component {

  render() {
    return <AppLogo />
  }
}



// WEBPACK FOOTER //
// ./src/components/Title.js